import { useContext } from 'react'

import { HttpRequestContext, HttpRequestContextType } from '../contexts/HttpRequestProvider'

export const useHttpRequestContext = () => useContext( HttpRequestContext ) as HttpRequestContextType